<div class="header">
  <h2>Creazione <strong>Nuovo Requisito</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a [routerLink]="['/checklist']">Checklist</a></li>
      <li><a [routerLink]="['/checklist/' + checklist.id_checklist]">Dettaglio Checklist</a></li>
      <li><a [routerLink]="['/checklist-category/' + checklistCategory.id_checklist_category]">Dettaglio Macro Categoria</a></li>
      <li class="active">Nuovo Requisito</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-content">
        <form (ngSubmit)="onSubmit()" #checklistSubCategoryCreateForm="ngForm" role="form" class="form-horizontal form-validation">
          <div class="form-group">
            <label for="checklist" class="col-sm-3 control-label">Checklist</label>
            <div class="col-sm-6">
              <input type="text"
                     id="checklist"
                     class="form-control-plaintext"
                     style="font-size: 1.4rem !important;"
                     readonly
                     [value]="checklist.name">
            </div>
          </div>

          <div class="form-group">
            <label for="checklist-category" class="col-sm-3 control-label">Macro Categoria Checklist</label>
            <div class="col-sm-6">
              <input type="text"
                     id="checklist-category"
                     class="form-control-plaintext"
                     style="font-size: 1.4rem !important;"
                     readonly
                     [value]="checklistCategory.name">
            </div>
          </div>

          <div class="form-group">
            <label for="code" class="col-sm-3 control-label">Codice *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="code"
                     name="code"
                     class="form-control"
                     placeholder="Inserisci Codice..."
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(code.valid || code.pristine),
                        'form-success': code.valid
                     }"
                     [(ngModel)]="checklistSubCategory.code"
                     #code="ngModel">
              <i class="icon-key"></i>
              <div [hidden]="code.valid || code.pristine"
                   class="form-error valid">
                Il codice è richiesto.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="title" class="col-sm-3 control-label">Titolo *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="title"
                     name="title"
                     class="form-control"
                     placeholder="Inserisci Titolo..."
                     minlength="3"
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(name.valid || name.pristine),
                        'form-success': name.valid
                     }"
                     [(ngModel)]="checklistSubCategory.name"
                     #name="ngModel">
              <i class="icon-info"></i>
              <div [hidden]="name.valid || name.pristine"
                   class="form-error valid">
                Inserisci almeno 3 caratteri.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="level" class="col-sm-3 control-label">Livello di Servizio</label>
            <div class="col-sm-6">
              <textarea type="text"
                        id="level"
                        name="level"
                        class="form-control"
                        rows="4"
                        autocomplete="off"
                        [(ngModel)]="checklistSubCategory.level">
              </textarea>
            </div>
          </div>

          <div class="form-group">
            <label for="level" class="col-sm-3 control-label">Standard di Riferimento</label>
            <div class="col-sm-6">
              <textarea type="text"
                        id="standard"
                        name="standard"
                        class="form-control"
                        rows="4"
                        autocomplete="off"
                        [(ngModel)]="checklistSubCategory.standard">
              </textarea>
            </div>
          </div>

          <div class="form-group">
            <label for="documents" class="col-sm-3 control-label">Documenti di Verifica</label>
            <div class="col-sm-6">
              <textarea type="text"
                        id="documents"
                        name="documents"
                        class="form-control"
                        rows="4"
                        autocomplete="off"
                        [(ngModel)]="checklistSubCategory.documents">
              </textarea>
            </div>
          </div>

          <div class="text-center m-t-20">
            <button type="submit"
                    class="btn btn-embossed btn-primary"
                    [disabled]="!checklistSubCategoryCreateForm.form.valid">
              <i class="icon-plus"></i> Crea nuovo Requisito</button>
          </div>

          <div [hidden]="checklistSubCategoryCreationResult" class="alert alert-danger">
            Non è stato possibile inserire il Requisito, riprovare.
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
